import { UserApplicationQuestionnaires } from '@dieterApi/user/useUserQuery';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

// code-snippet from https://mui.com/material-ui/react-menu/

interface DocumentMenuProps {
  anchorEl: HTMLElement | null;
  handleClose: () => void;
  app: UserApplicationQuestionnaires;
  onShow: (index: number) => void;
}

export default function DocumentMenu({ anchorEl, handleClose, app, onShow }: DocumentMenuProps) {
  const { t } = useTranslation();

  const open = Boolean(anchorEl);

  return (
    <React.Fragment>
      <Menu
        className="dtAccountMenu"
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            // overflow: 'visible',
            maxHeight: '600px',
            overflowY: 'auto',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {app.documentLabels.map((label, idx) => {
          return (
            <MenuItem key={label}>
              <button
                onClick={() => {
                  onShow(idx);
                }}
              >
                {label}
              </button>
            </MenuItem>
          );
        })}
      </Menu>
    </React.Fragment>
  );
}
